import Navbar from '../nav-bar';
import { connect } from 'react-redux';

// Layout component
const Layout = props => {
  return (
    <div className="flex flex-col">
      <Navbar />
      <main className="bg-gradient-to-br from-slate-50 via-white to-blue-50">
        {props.children}
      </main>
    </div>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    overviewInfo: state.pecrInfo.overview,
    pecrId: state.pecrInfo.pecrData.pecrId,
    userInfo: state.userInfo,
  };
};

export default connect(mapStateToProps, null)(Layout);
